import { KeyRound, Network, Router } from "lucide-react";
import { MmcFrame } from "../../admin-framework/MmcFrame.js";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

export function DhcpManagerApp({ activeMachine, app, onRunCommand }: SimulatorAppSurfaceProps) {
  const run = (commandType: string, capability: string, label: string, payload: Record<string, unknown>) => {
    void onRunCommand({ appId: app.id, capability, commandType, label, payload: { machineId: activeMachine, ...payload } });
  };

  const scopePayload = {
    active: true,
    dnsServer: "10.50.20.10",
    domainName: "advanced-ti.local",
    endIp: "10.50.20.180",
    name: "Balie-152",
    router: "10.50.20.1",
    scopeName: "Balie-152",
    startIp: "10.50.20.100",
    subnetMask: "255.255.255.0"
  };

  return (
    <div className="fd-sim-app fd-sim-admin-tool">
      <MmcFrame
        title={app.title}
        actions={[
          { label: "New Scope", onClick: () => run("DHCP_CREATE_SCOPE", "dhcp.scope.write", "New Scope", scopePayload) },
          { label: "Scope Options", onClick: () => run("DHCP_SET_OPTION", "dhcp.option.write", "Scope Options", { dnsServer: "10.50.20.10", domainName: "advanced-ti.local", router: "10.50.20.1", scopeName: "Balie-152" }) },
          { label: "Reservation", onClick: () => run("DHCP_ADD_RESERVATION", "dhcp.reservation.write", "Reservation", { ipAddress: "10.50.20.152", macAddress: "00-15-5D-15-20-52", reservationName: "WS-152", scopeName: "Balie-152" }) }
        ]}
        columns={[
          { key: "name", label: "Name" },
          { key: "range", label: "Address range" },
          { key: "status", label: "Status" }
        ]}
        rows={[
          { id: "scope", values: { name: "Balie-152", range: "10.50.20.100 - 10.50.20.180", status: "Active" }, onDoubleClick: () => run("DHCP_CREATE_SCOPE", "dhcp.scope.write", "New Scope", scopePayload) },
          { id: "reservation", values: { name: "WS-152", range: "10.50.20.152", status: "Reserved" }, onDoubleClick: () => run("DHCP_ADD_RESERVATION", "dhcp.reservation.write", "Reservation", { ipAddress: "10.50.20.152", macAddress: "00-15-5D-15-20-52", reservationName: "WS-152", scopeName: "Balie-152" }) },
          { id: "option", values: { name: "006 DNS Servers", range: "10.50.20.10", status: "Scope option" }, onDoubleClick: () => run("DHCP_SET_OPTION", "dhcp.option.write", "Scope Options", { dnsServer: "10.50.20.10", domainName: "advanced-ti.local", router: "10.50.20.1", scopeName: "Balie-152" }) }
        ]}
        tree={[
          { active: true, id: "server", icon: <Router size={16} />, label: "SRV01.advanced-ti.local" },
          { id: "ipv4", icon: <Network size={16} />, label: "IPv4" },
          { active: true, id: "scope", icon: <Network size={16} />, label: "Balie-152" },
          { id: "reservations", icon: <KeyRound size={16} />, label: "Reservations" }
        ]}
      />
    </div>
  );
}
